export const BU_ICON_COLORS = [
  'white',
  'light',
  'dark',
  'black',
  'text',
  'primary',
  'link',
  'info',
  'success',
  'warning',
  'danger'
];

export const BU_ICON_SIZES = [
  'small',
  'medium',
  'large'
];
